export default {
    button: 'Не удалось завершить задачу, обратитесь в Поддержку ИТ',

    confirming: {
        name: 'Изменения согласованы',
        cancel: 'Отмена согласована',
        confirm: 'Изменения заказа согласованы с клиентом?',
        cancelConfirm: 'Отмена согласована с клиентом?',
        disband: 'Расформировать',
        callFailed: 'Недозвон',
    },

    formatting: {
        name: 'Сформировать',
        confirm: 'Подтвердите завершение формирования заказа. После подтверждения скорректировать заказ будет невозможно.',
        confirmOk: 'Подтверждаю',
        confirmCancel: 'Вернуться к изменению заказа',
        confirmApproved: 'Заказ сформирован! Для дальнейшей работы с заказом перейдите станционарный ПК.',
        confirmAdditional: "Заказ сформирован! Для печати заказа с 'мягким' чеком перейдите к стационарному ПК.",
        confirmApprovedOK: 'Хорошо',
        // eslint-disable-next-line max-len
        textTooltip: 'Невозможно собрать заказ, пока количество заказанных и количество собранных товаров не сравняются, или пока не будет указана причина изменения несобранной позиции',
        // eslint-disable-next-line max-len
        textTooltipNeedPackage: 'Невозможно собрать заказ, пока количество заказанных товаров и количество собранных товаров не сравняются, или пока не будет указана причина изменения несобранной позиции, или пока не будет добавлен хотя бы 1 пакет',
        bvModal: 'В заказе имеются неиспользуемые тары, удалить неиспользуемые позиции?',
    },

    listDisbanding: {
        name: 'Расформировать',
        confirm: 'Заказ расформирован?',
    },

    listPaying: {
        name: 'Оплачен и выдан',
        confirm: 'Заказ оплачен и выдан клиенту?',
    },

    listPrint: {
        name: 'Распечатано',
        confirm: 'Документы распечатаны',
        confirmOk: 'Да',
        confirmCancel: 'Нет',
    },
};